<template>
  <div
    v-if="dialogInternal"
    class="load d-flex align-center justify-center"
    :style="'position: fixed; left: 0; top: 0; z-index: 999999; width: 100%; height: 100%;'"
  >
    <v-card
      id="ConfirmDialog"
      class="pa-5 grow-box d-flex flex-column px-8"
      elevation="10"
      :style="'max-width: 400px; z-index: 1; max-height: 80%; width: 100%; overflow-y: auto; overflow-x: hidden; border: 1px solid var(--v-foreground2-base); background: var(--v-background-base);'"
    >
      <h2
        v-if="title"
        class="text-center mb-5"
        style="width: 100%;"
      >{{ title }}</h2>

      <div
        class="mb-5 text-center"
        style="white-space: break-spaces;"
        v-html="message"
      ></div>

      <div
        v-if="data && data.length > 0"
        class="mb-5 text-left"
        style="white-space: break-spaces;"
      >{{ data }}</div>

      <div
        class="d-flex justify-space-between align-center"
      >

        <v-btn
          @click="$emit('cancel')"
          color="red"
          style="color: white; min-width: 120px;"
        >{{ cancelText }}</v-btn>

        <v-btn
          @click="$emit('confirm', passthrough)"
          color="blue"
          style="color: white; min-width: 120px;"
          :loading="loading"
        >{{ confirmText }}</v-btn>

      </div>

    </v-card>
    <div
      id="Background"
      class="clear"
      style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 0; background: #00000030;"
    ></div>
  </div>
</template>
<script>
export default {
  name: 'ConfirmDialog',

  components: {

  },

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },

    title: {
      type: String,
      required: false,
      default: 'Confirm',
    },

    message: {
      type: String,
      required: false,
      default: 'Would you like to confirm your choice?'
    },

    data: {
      type: String,
      required: false,
      default: '',
    },

    cancelText: {
      type: String,
      required: false,
      default: 'Cancel',
    },

    confirmText: {
      type: String,
      required: false,
      default: 'Confirm',
    },

    loading: {
      type: Boolean,
      required: false,
      default: false,
    },

    passthrough: {
      required: false,
    }
  },

  data: () => ({
    dialogInternal: false,
    closeDialog: false,
  }),

  watch: {
    dialog(e) {
      this.dialogInternal = e;
    },

    dialogInternal(e) {
      if (e === false) {
        this.$emit('dialog', false);
      }
      else {
        setTimeout(() => document.getElementById('Background').classList.add('opaque'), 0);
      }
    },

    closeDialog(v) {
      if (v) {
        if (!this.noClose) {
          document.getElementById('ConfirmDialog').classList.add('shrink-box');
          document.getElementById('ConfirmDialog').classList.remove('grow-box');
          setTimeout(() => document.getElementById('Background').classList.remove('opaque'), 0);
          setTimeout(() => { this.dialogInternal = false; this.closeDialog = false; this.$emit('dialog', false); }, 150)
        }
        else {
          setTimeout(() => { this.$emit('dialog', false); }, 150)
        }
      }
    }
  },

  computed: {

  },

  methods: {
    keyDown(e) {
      if (this.dialog && e.key === 'Escape') {
        this.closeDialog = true;
      }

      if (this.dialog && e.key === 'Enter') {
        this.$emit('confirm', this.passthrough);
      }
    }
  },

  destroyed() {
    window.removeEventListener('keydown', this.keyDown, true);
  },

  created() {
    window.addEventListener('keydown', this.keyDown, true);
    this.dialogInternal = false;
    this.$emit('dialog', false);
  },

  mounted() {

  }
}
</script>
<style>
  #Background {
    transition: opacity 0.3s;
    -webkit-transition: opacity 0.3s;
  }

  .clear {
    opacity: 0;
  }

  .opaque {
    opacity: 1;
  }
</style>
